import { render, staticRenderFns } from "./chatMessageCount.vue?vue&type=template&id=5a34cb14&scoped=true&"
import script from "./chatMessageCount.vue?vue&type=script&lang=js&"
export * from "./chatMessageCount.vue?vue&type=script&lang=js&"
import style0 from "./chatMessageCount.vue?vue&type=style&index=0&id=5a34cb14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a34cb14",
  null
  
)

export default component.exports